<div class="foreclosure-discount-wrapper">
    <div>Generell tvangssalgsrabatt</div>

    <div class="percentage-icon" 
        (clickOutside)="closeScoreInformation()" 
        (click)="openScoreInformation()"
        cdkOverlayOrigin #percentage="cdkOverlayOrigin">
            {{ foreclosureDiscount().discountInPercentage | number : "1.0-0" }}%

        <ev-cdk-tooltip
            [origin]="percentage"
            [visible]="scoreTooltipOpen"
            [title]="'Generell tvangssalgsrabatt'"
            width="400px"
            (close)="closeScoreInformation()"
        >
            <div class="score-popup">
                <div class="score-dialog">
                    Generell tvangssalgsrabatt er et anslag på gjennomsnittlig avvik mellom realisert pris og evEstimat ved tvangssalg. Anslaget gjelder for
                    alle boliger i Norge innenfor tilsvarende boligtype og områdescore, men er ikke et uttrykk for eventuell tvangssalgsrabatt for akkurat denne
                    boligen.
                </div>
            </div>
        </ev-cdk-tooltip>
    </div>
</div>
